import { LOCAL_STORAGE_VALUES } from 'common/constants'
import LocalStorageService from 'common/utils/LocalStorageService'

export const getPendingJoinedGroups = (): string[] => {
  const existing = LocalStorageService.getItem(LOCAL_STORAGE_VALUES.PENDING_JOINED_GROUPS)
  if (!existing) return []
  return JSON.parse(existing) as string[]
}

export const addPendingJoinedGroup = (groupId: string) => {
  const pendingGroups = getPendingJoinedGroups()
  if (!pendingGroups.includes(groupId)) {
    pendingGroups.push(groupId)
    LocalStorageService.setItem(LOCAL_STORAGE_VALUES.PENDING_JOINED_GROUPS, JSON.stringify(pendingGroups))
  }
}

export const removePendingJoinedGroup = (groupId: string) => {
  const pendingGroups = getPendingJoinedGroups()
  const updatedGroups = pendingGroups.filter((id) => id !== groupId)

  if (updatedGroups.length > 0) {
    LocalStorageService.setItem(LOCAL_STORAGE_VALUES.PENDING_JOINED_GROUPS, JSON.stringify(updatedGroups))
  } else {
    LocalStorageService.removeItem(LOCAL_STORAGE_VALUES.PENDING_JOINED_GROUPS)
  }
}

export const isPendingJoinedGroup = (groupId: string): boolean => {
  const pendingGroups = getPendingJoinedGroups()
  return pendingGroups.includes(groupId)
}
